import { Box, LinearProgress, Typography } from "@mui/material";
import React from "react";

export default function TimelineBarInside({
  startDate,
  endDate,
  progressValue,
}: {
  startDate: string;
  endDate: string;
  progressValue: number;
}) {
  return (
    <Box position="relative" display="inline-flex" width="100%">
      <LinearProgress
        variant="determinate"
        sx={{ height: "22px", width: "100%", borderRadius: "16px" }}
        value={progressValue < 100 ? progressValue : 100}
      />
      <Box
        top={0}
        left={0}
        bottom={0}
        right={0}
        position="absolute"
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <Typography variant="body2" color="white">
          {`${startDate} - ${endDate}`}
        </Typography>
      </Box>
    </Box>
  );
}
